import { render } from "./HighlightsComponent.vue?vue&type=template&id=ad474d82"
import script from "./HighlightsComponent.vue?vue&type=script&lang=js"
export * from "./HighlightsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__